import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer';
import { connect } from 'react-redux';
import { removeScript  } from '../Utils/Utils';
import LoadingSpinner from '../Layout/LoadingSpinner';
import InstructorDetailComponent from '../components/AllInstructorList/InstructorDetail'
import LandingBannerNew from '../components/LandingNew/LandingBannerNew'

class InstructorDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  fetchInstructorsDetail = () => {

    }

  componentDidMount = async () => {
  };

  componentWillUnmount() {
    removeScript('https://app.sandbox.midtrans.com/snap/snap.js');
  }

  render() {
    return (
      <>
        <Header/>
        <div className="container container-homepage d-flex flex-column container-instructor-detail">
          <LandingBannerNew/>
          <InstructorDetailComponent/>
        </div>
        <Footer />
        {this.props.isLoading ? <LoadingSpinner text={"Mohon menunggu.."} /> : ''}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { isLoading: state.isLoading, instructorList: state.instructor_selected };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstructorDetail);
